export default __webpack_public_path__ + "static/feature_04-e65aa05473a633784ba661e89eed0151.png";